import React, { FunctionComponent } from 'react';
import { PrimaryButton, TertiaryButton } from '@components/library/button';

interface SuccessProps {
  newAssetLink: string;
  singleFile: boolean;
}

export const SubmitSuccess: FunctionComponent<SuccessProps> = ({
  newAssetLink,
  singleFile,
}) => {
  const successCopy = singleFile
    ? bfTranslate('Your file has been successfully uploaded.')
    : bfTranslate('Your files have been successfully uploaded.');

  const onVisitBrandfolder = (): void => {
    window.open(newAssetLink);
    window.close();
  };

  return (
    <div className="submit-success">
      <div className="submit-success__header">
        <span className="bff-confirmation icon" />
        <h4 className="submit-success__header--title">{bfTranslate('Thank you!')}</h4>
      </div>
      <p className="submit-success__instructions">{successCopy}</p>
      <div className="submit-success__buttons">
        <TertiaryButton
          onClick={(): void => { window.close(); }}
          size="small"
        >
          {bfTranslate('Done')}
        </TertiaryButton>
        <PrimaryButton
          onClick={onVisitBrandfolder}
          size="medium"
        >
          {bfTranslate('Visit the Brandfolder')}
        </PrimaryButton>
      </div>
    </div>
  );
};
